"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSubmitDigestPreferencesResponseDto = instanceOfSubmitDigestPreferencesResponseDto;
exports.SubmitDigestPreferencesResponseDtoFromJSON = SubmitDigestPreferencesResponseDtoFromJSON;
exports.SubmitDigestPreferencesResponseDtoFromJSONTyped = SubmitDigestPreferencesResponseDtoFromJSONTyped;
exports.SubmitDigestPreferencesResponseDtoToJSON = SubmitDigestPreferencesResponseDtoToJSON;
exports.SubmitDigestPreferencesResponseDtoToJSONTyped = SubmitDigestPreferencesResponseDtoToJSONTyped;
/**
 * Check if a given object implements the SubmitDigestPreferencesResponseDto interface.
 */
function instanceOfSubmitDigestPreferencesResponseDto(value) {
    if (!('visitorId' in value) || value['visitorId'] === undefined)
        return false;
    if (!('sessionId' in value) || value['sessionId'] === undefined)
        return false;
    if (!('savedAt' in value) || value['savedAt'] === undefined)
        return false;
    return true;
}
function SubmitDigestPreferencesResponseDtoFromJSON(json) {
    return SubmitDigestPreferencesResponseDtoFromJSONTyped(json, false);
}
function SubmitDigestPreferencesResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'visitorId': json['visitorId'],
        'sessionId': json['sessionId'],
        'savedAt': json['savedAt'],
    };
}
function SubmitDigestPreferencesResponseDtoToJSON(json) {
    return SubmitDigestPreferencesResponseDtoToJSONTyped(json, false);
}
function SubmitDigestPreferencesResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'visitorId': value['visitorId'],
        'sessionId': value['sessionId'],
        'savedAt': value['savedAt'],
    };
}
